import { apiFor } from './client';
import { worldCupEnvelopeSchema, type WorldCupEnvelope } from './worldCup';

/**
 * `reportId` is the catalog key for the current client (e.g. `world-cup-engagement`
 * for Brazil, `carrefour-spain-world-cup` for Spain). `baseUrl` selects the
 * backend to ask — each region runs on its own server, with its own auth.
 */
export async function getWorldCupReport(reportId: string, baseUrl: string): Promise<WorldCupEnvelope> {
  const raw = await apiFor(baseUrl).get(`reports/${reportId}`).json();
  return worldCupEnvelopeSchema.parse(raw);
}

/**
 * Download the client Excel export for a report. Fetches the .xlsx through the
 * authenticated client (so the bearer token rides along — a plain <a href>
 * couldn't), then triggers a browser download. Throws if the report has no
 * export (404) so the caller can surface an error.
 */
export async function downloadReportExport(reportId: string, baseUrl: string): Promise<void> {
  const blob = await apiFor(baseUrl).get(`reports/${reportId}/export.xlsx`).blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${reportId}.xlsx`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
